module.exports = __webpack_public_path__ + "img/icon-tg.d9c16e71.svg";